import React from 'react';
// import { useLanguage } from '../../../i18n/LanguageContext'; // Will be used for future translations

const MusicCard = ({ music, onShowLyrics }) => {
  // const { language } = useLanguage(); // Will be used for future translations

  const handleCardClick = () => {
    onShowLyrics(music);
  };

  return (
    <div 
      className="bg-white rounded-lg shadow-md hover:shadow-lg transition-all duration-300 p-4 cursor-pointer group"
      onClick={handleCardClick}
    >
      <div className="flex items-center space-x-4">
        {/* Thumbnail */}
        <div className="relative">
          <img 
            src={music.thumbnail} 
            alt={music.title}
            className="w-16 h-16 rounded-lg object-cover"
            onError={(e) => {
              e.target.src = 'https://via.placeholder.com/64x64/FF6B35/FFFFFF?text=🎵';
            }}
          />
        </div>

        {/* Title */}
        <div className="flex-1 min-w-0">
          <h3 className="font-semibold text-gray-800 truncate group-hover:text-orange-600 transition-colors">
            {music.title}
          </h3>
          <p className="text-sm text-gray-500 capitalize">
            {music.type}
          </p>
        </div>

      </div>
    </div>
  );
};

export default MusicCard;
